import { render, staticRenderFns } from "./payment-success.vue?vue&type=template&id=68fa21bb&scoped=true"
import script from "./payment-success.vue?vue&type=script&lang=js"
export * from "./payment-success.vue?vue&type=script&lang=js"
import style0 from "./payment-success.vue?vue&type=style&index=0&id=68fa21bb&prod&lang=scss&scoped=true"
import style1 from "./payment-success.vue?vue&type=style&index=1&id=68fa21bb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fa21bb",
  null
  
)

export default component.exports